import styled from 'styled-components';

const TabBarContainer = styled.div`
  width: 100%;
  min-height: 40px;
  border-radius: 8px;
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  border: 1px solid ${props => props.theme.colors.grey};
  overflow: hidden;
  overflow-x: auto;
  margin-bottom: 20px;
`;

const TabBarItemContainer = styled.div`
  height: 100%;
  flex-shrink: 0;
  min-width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid ${props => props.theme.colors.grey};
  font-size: ${props => props.theme.font.sm};
  font-weight: ${props => props.theme.font.bold};
  text-align: center;
  cursor: pointer;
  padding: 5px 0;
  ${props =>
    props.active &&
    `
    background: ${props.theme.colors.primary};
    color: ${props.theme.colors.white};
  `}
`;

export { TabBarContainer, TabBarItemContainer };
